export const normalizeCompanyLinkSiteId = (
  siteId: string | null | undefined
): string => siteId ?? '';
